import React, { useEffect } from "react";
import { scrollTopFun } from "../utils";

const ScrollTop = () => {
  useEffect(() => {
    scrollTopFun();
  }, []);
  const onClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      className="back-to-top"
      aria-label="Back to top"
      onClick={onClick}
      id="scroll-top"
    >
      <span className="sr-only">Back to top</span>
      <i className="far fa-angle-up" aria-hidden="true" />
    </button>
  );
};
export default ScrollTop;
